import React from "react";

import CheckboxOption from "wxrecall/components/SearchResults/CheckboxOption";

import "wxrecall/components/SearchResults/DisplayOptions.css";

// This component renders the display options for the Search results:
// Display Metadata
// Display Timestamps

// On mobile, we don't show metadata so don't bother showing the toggle.
export default function DisplayOptions(props) {
  let controlsClasses = [];
  let mobileSize = "";

  if (props.mobile) {
    // On mobile, just use the entire row because this and the sort controls will be on separate lines
    // Also don't left justify (because it looks terrible)
    mobileSize = "span12";
  } else {
    // On desktop / tablet, only take up half the available space because this and the sort control are
    // side-by-side. Also left justify because both Display controls are displayed on top of each other
    // and it looks better.
    mobileSize = "span6";
    controlsClasses.push("display-options");
  }

  controlsClasses.push(mobileSize);

  return (
    <div className={controlsClasses.join(" ")}>
      {!props.mobile && (
        <div className="row-fluid">
          <div className="span6 offset5">
            <CheckboxOption
              label="metadata"
              checked={props.showMeta}
              onChange={props.handleCheckMeta}
            />
          </div>
        </div>
      )}
    </div>
  );
}
